import { plainAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class LeadsService {
  create(params) {
    return plainAxiosInstance.post("/public/leads", toSnakeCase(params));
  }

  verifyConsentCode(uniqueToken, consentCode) {
    return plainAxiosInstance.put(`/public/leads/${uniqueToken}/verify_consent_code`, {
      consent_code: consentCode,
    });
  }
}

export default new LeadsService();
